import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useTranslateText from './use_translate_text';
import '../scss/button.scss';

export const PrimaryButton = (props) => {
  const { className, onClick, icon, size, label, isDisabled } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button ${className}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size || '1px'}
        className={className}
      />
      {translateText(label)}
    </button>
  );
};

export const PrimaryButtonRight = (props) => {
  const { className, onClick, icon, size, label, isDisabled } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__right ${className}`;
  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size || '1px'}
      />
      {translateText(label)}
    </button>
  );
};

export const PrimaryButtonCircle = (props) => {
  const { className, onClick, icon, size, label, isDisabled } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__circle ${className}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size || '1px'}
      />
      {translateText(label)}
    </button>
  );
};

export const PrimaryButtonRoundBorder = (props) => {
  const { className, onClick, icon, size, label, isDisabled, style = {} } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__round-border ${className}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
      style={style}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size || '1px'}
      />
      {translateText(label)}
    </button>
  );
};

export const PrimaryButtonCloseIcon = (props) => {
  const { className, onClick, icon, size, label, isDisabled } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__close-icon ${className}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size || '1px'}
      />
      {translateText(label)}
    </button>
  );
};

export default PrimaryButton;